import 'es6-shim';
import 'react-app-polyfill/ie11';
import { SpellcheckLite } from "library/src/Views/SpellcheckLite/SpellcheckLite";
import { Settings } from 'library/src/Components/Settings/Settings';
import { DeskWrapper } from 'library/src/Components/Desk';
import { User } from 'library/src/Components/User/User';
import { DocumentIdentifier } from 'library/src/Util/DocumentIdentifier';
import { PlatformTypes } from 'library/src/Util/PlatformUtil';
import 'nodelist-foreach-polyfill';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store }  from './Store';

import 'library/src/Styles/BaseStyles.ts';

DocumentIdentifier.setPlatformIdentifier(PlatformTypes.lite);

window.addEventListener(
    'touchstart',
    function onFirstTouch(): void {
        document.body.classList.add('user__can-touch');
        window.removeEventListener('touchstart', onFirstTouch, false);
    },
    false,
);

ReactDOM.render(
    (
        <Provider store={store}>
            <Settings>
                <User>
                    <DeskWrapper>
                        <SpellcheckLite />
                    </DeskWrapper>
                </User>
            </Settings>
        </Provider>
    ),
    document.getElementById('root'),
);
